


























































import {
  Component,
  Vue,
} from 'vue-property-decorator';

import bImg from 'bootstrap-vue/es/components/image/img';
import bCarousel from 'bootstrap-vue/es/components/carousel/carousel';
import bCarouselSlide from 'bootstrap-vue/es/components/carousel/carousel-slide';

export interface Slide {
  id: string;
  imageSrc: string;
  imageAlt: string;
  link: string;
  // TODO: Provide description for slide with https://bootstrap-vue.js.org/docs/components/jumbotron.
}

export enum CarouselSectionHeight {
  Small = 'small',   // 300px
  Medium = 'medium', // 450px
  Large = 'large',   // 600px
}

const CarouselProps = Vue.extend({
  props: {
    slides: {
      type: Array as () => Slide[],
      required: true,
    },
    interval: {
      type: Number,
      default: 5000,
    },
    height: {
      type: String as () => CarouselSectionHeight,
      default: CarouselSectionHeight.Medium,
    },
  },
});

@Component({
  components: {
    bImg,
    bCarousel,
    bCarouselSlide,
  },
})
export default class Carousel extends CarouselProps {
  get classObj() {
    return [
      `${this.height}-carousel-height`,
      'page-section',
      'carousel-section',
      'mx-auto',
    ];
  }
}
